import React from 'react';
import { Check, AlertTriangle, CalendarClock } from 'lucide-react';
import { eur } from '../RatenShared';

const MONATE = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

// Portal: alle Einzugstermine eines Ratenplans als Monatskacheln mit Restschuld nach jeder Rate
export const EinzugsKalender = ({ raten = [], testid = 'einzugs-kalender' }) => {
  const offen = raten.filter((r) => r.status !== 'bezahlt');
  let rest = offen.reduce((s, r) => s + (r.betrag || 0), 0);
  const naechste = offen.find((r) => r.status === 'offen')?.nr;
  const dt = (v) => new Date(`${v}T00:00:00`).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const kacheln = raten.map((r) => {
    if (r.status !== 'bezahlt') rest -= r.betrag || 0;
    return { ...r, rest: Math.max(0, Math.round(rest * 100) / 100) };
  });
  return (
    <div data-testid={testid}>
      <p className="flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase text-[#b8893d] mb-2"><CalendarClock className="w-3.5 h-3.5" />Einzugskalender</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
        {kacheln.map((r) => {
          const d = new Date(`${r.faellig_am}T00:00:00`);
          const bezahlt = r.status === 'bezahlt';
          const fehl = r.status === 'fehlgeschlagen';
          const ist = r.nr === naechste;
          return (
            <div key={r.nr} className={`rounded-xl border p-3 transition-colors ${bezahlt ? 'bg-gray-50 border-gray-100 opacity-70' : fehl ? 'bg-rose-50 border-rose-200' : ist ? 'bg-[#fbf7f0] border-[#b8893d]' : 'bg-white border-gray-200'}`} data-testid={`${testid}-rate-${r.nr}`}>
              <div className="flex items-baseline justify-between">
                <span className="font-serif text-lg text-[#1B3A5C]">{MONATE[d.getMonth()]} <span className="text-xs text-[#7a8a99]">{d.getFullYear()}</span></span>
                {bezahlt ? <Check className="w-4 h-4 text-emerald-600" /> : fehl ? <AlertTriangle className="w-4 h-4 text-rose-600" /> : ist ? <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-[#b8893d] text-white">nächste</span> : null}
              </div>
              <p className="text-[11px] text-[#7a8a99]">{dt(r.faellig_am)} · Rate {r.nr}</p>
              <p className="text-sm font-semibold text-[#1B3A5C] mt-1" data-testid={`${testid}-betrag-${r.nr}`}>{eur(r.betrag)}</p>
              <p className="text-[11px] text-[#34536b]" data-testid={`${testid}-rest-${r.nr}`}>{bezahlt ? 'bezahlt' : fehl ? (r.erneut_geplant_am ? `erneuter Einzug am ${dt(r.erneut_geplant_am)}` : 'nicht eingezogen – wir melden uns') : <>danach offen: <span className="whitespace-nowrap">{eur(r.rest)}</span></>}</p>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-[#34536b] mt-2" data-testid={`${testid}-restschuld`}>Aktuelle Restschuld: <b>{eur(offen.reduce((s, r) => s + (r.betrag || 0), 0))}</b></p>
    </div>
  );
};

export default EinzugsKalender;
